import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import theme from "../../../theme/Theme";
import { UpdateWorker } from "../../../queries/Workers";

const endCollectionOptions = [
  { value: 0, name: "Immediately" },
  { value: 0.5, name: "Half day" },
  { value: 1, name: "1 day" },
  { value: 2, name: "2 days" },
  { value: 3, name: "3 days" },
  { value: 4, name: "4 days" },
  { value: 5, name: "5 days" },
  { value: 6, name: "6 days" },
  { value: 7, name: "7 days" },
];

const getDateAfterDays = (days) => {
  const currentDate = new Date(); // Get the current date in UTC
  const millisecondsToAdd = days * 24 * 60 * 60 * 1000;
  currentDate.setTime(currentDate.getTime() + millisecondsToAdd); // Add the specified number of days
    return currentDate.toISOString(); // Convert to ISO format 
};

export const EndCollectionSelect = (props: any) => {
  const [selectedValue, setSelectedValue] = useState(
    new Date() < new Date(props.data?.end_qa_date)
      ? endCollectionOptions?.find(
          (option) => option.value === props?.data?.days_in_qa
        )?.name
      : null
  );

  const handleSelect = async (ev, val) => {
    const value = endCollectionOptions?.find(
      (option) => option.value === ev.target.value
    )?.name;
    const endDate = getDateAfterDays(ev.target.value);
    props?.client
      .mutate({
        mutation: UpdateWorker,
        variables: {
          id: props?.data?.worker_id,
          worker: {
            end_qa_date: endDate,
            days_in_qa: parseFloat(ev.target.value),
          },
        },
      })
      .then((response: any) => {
        const rowNode = props.api?.getRowNode(props?.node?.id);
        if (!rowNode) return;
        const updatedData = rowNode.data;
        updatedData.end_qa_date = endDate;
        rowNode.updateData(updatedData);
        props.api?.refreshCells({ rowNodes: [rowNode], force: true });
        setSelectedValue(value);
      })
      .catch((err) => console.error(err));
  };

  return (
    <FormControl sx={{ width: "100%" }}>
      <Select
        value={selectedValue}
        displayEmpty
        variant="filled"
        size="small"
        autoWidth
        onChange={(ev, val) => handleSelect(ev, val)}
        renderValue={(selected) => {
          if (selected === null) {
            return (
              <div style={{ color: theme.palette.artisticTextLow.main }}>
                please select
              </div>
            );
          }

          return <div>{selected}</div>;
        }}
        sx={{
          width: "100%",
          padding: 0,
          height: "30px",
          background: theme.palette.artisticStructural200.main,
          border: "none",
          outline: "none",
          borderRadius: 0,
          "& select": {
            height: "30px",
          },
          "&:hover, &.Mui-focused": {
            background: theme.palette.artisticStructural200.main,
            padding: 0,
            paddingTop: 0,
          },
          "& .MuiFilledInput-input": {
            paddingTop: 0,
            paddingBottom: 0,
          },
        }}
      >
        {endCollectionOptions?.map((option) => (
          <MenuItem
            key={option?.value}
            value={option?.value}
            sx={{ padding: "8px 16px" }}
          >
            {option?.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
